import { useQuery } from "@tanstack/react-query";
import { getGroups } from "../services/group.service";
import { IGetGroupsResponse } from "../types/group.types";

export const useGroups = () => {
  const query = useQuery<IGetGroupsResponse>({
    queryKey: ["groups"],
    queryFn: getGroups,
  });

  return query;
};
